import { Component, ElementRef } from "@angular/core";

import { BfxDialogOKComponent } from "./bfx-dialog-ok.component";
import { BfxDialogData } from "app/bfx-dialogs/models/bfx-dialog-data.model";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { GoldenLayoutService } from "app/golden-layout/golden-layout-service";
import { OrdersTableDefinitionFactory } from "shared/cubiq-services";

@Component({
  selector: `bfx-dialog-ok-cancel`,
  templateUrl: `./html/bfx-dialog-ok.html`,
  standalone: false,
})
export class BfxDialogOKCancelComponent extends BfxDialogOKComponent {
  constructor(
    layoutService: GoldenLayoutService,
    translationService: TranslateService,
    ordersTableDefinitionFactory: OrdersTableDefinitionFactory,
    element: ElementRef,
  ) {
    super(layoutService, translationService, ordersTableDefinitionFactory, element);
    this.cancelLabel = "Cancel";
  }

  public override openDialog(dialogData: BfxDialogData): Observable<any> {
    const { okLabel, cancelLabel } = dialogData.payload;
    if (okLabel) {
      this.okLabel = okLabel;
    }
    if (cancelLabel) {
      this.cancelLabel = cancelLabel;
    }
    return super.openDialog(dialogData);
  }
}
